import React from 'react';
import classNames from 'classnames';
import Container from "@scentregroup/ui/components/container";
import Paragraph from "@scentregroup/ui/components/paragraph";
import Logo from "@scentregroup/ui/components/logo";
import { RESPONSIBLE_BUSINESS, RESPONSIBLE_BUSINESS_REPORT, SCENTRE_GROUP_HOME } from '../paths';
import { FooterSection } from './footer-section';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SiteFooter = ({
  className = null,
  colour = 'seasonal',
  children,
  links = [],
  showAngle = true
}) => /*#__PURE__*/_jsx("footer", {
  className: classNames(style.siteFooter, className, {
    [style.showAngle]: showAngle,
    [style.seasonal]: showAngle && colour === 'seasonal',
    [style.brand]: showAngle && colour === 'brand'
  }),
  role: "contentinfo",
  children: /*#__PURE__*/_jsxs(Container, {
    className: style.container,
    type: "large",
    children: [/*#__PURE__*/_jsx(Logo, {
      type: "alt",
      className: style.logo
    }), children && /*#__PURE__*/_jsx(FooterSection, {
      children: children
    }), /*#__PURE__*/_jsxs(FooterSection, {
      className: style.linksSection,
      children: [/*#__PURE__*/_jsxs(Paragraph, {
        className: style.responsibleBusinessSection,
        children: ["Scentre Group operates its Westfield Living Centre portfolio with a", ' ', /*#__PURE__*/_jsx("a", {
          href: RESPONSIBLE_BUSINESS,
          children: "responsible business"
        }), " mindest across the four pillars of community, people, environment and economic performance. More information can be found in our", ' ', /*#__PURE__*/_jsx("a", {
          className: style.highlight,
          href: RESPONSIBLE_BUSINESS_REPORT,
          children: "2021 Responsible Business Report"
        }), "."]
      }), /*#__PURE__*/_jsxs("div", {
        className: style.linksWrapper,
        children: [links && /*#__PURE__*/_jsx("ul", {
          className: style.linksList,
          children: links.map(({
            label,
            href
          }) => /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx("a", {
              href: href,
              className: style.link,
              children: label
            })
          }, href))
        }), /*#__PURE__*/_jsxs("span", {
          className: style.rightsText,
          children: ["\xA9 All rights reserved", ' ', /*#__PURE__*/_jsx("a", {
            href: SCENTRE_GROUP_HOME,
            className: style.highlight,
            children: "Scentre Group"
          }), ' ', new Date().getFullYear()]
        })]
      })]
    })]
  })
});